import { render, staticRenderFns } from "./CWinPop.vue?vue&type=template&id=247565d0"
import script from "./CWinPop.vue?vue&type=script&lang=js"
export * from "./CWinPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('247565d0')) {
      api.createRecord('247565d0', component.options)
    } else {
      api.reload('247565d0', component.options)
    }
    module.hot.accept("./CWinPop.vue?vue&type=template&id=247565d0", function () {
      api.rerender('247565d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CWinPop.vue"
export default component.exports